import { CsvParseUtils, Utils } from '@qality/common-utils';

// TO DO @pmaj
// as it's hidden and hardcoded fieldname
// have to modify and find better place to do it
// make it functional, update form at step when UI changes are made
export const uploadFilesSubmit = (values) => {
  const { file, delimiter, encoding } = values;
  const { csv: { meta: { fields: prevFields = [] } = {} } = {} } = file;
  const prevFieldsS = prevFields.join('JOINXYZSOLDEVELOUNIQUE');
  const newFile = Object.assign(file);
  newFile.csv = CsvParseUtils.getParsedCSV(
    file.content,
    delimiter.value,
    encoding
  );
  deleteRedundantFields(newFile);

  let { fields = [] } = newFile.csv.meta;
  fields = fields.filter((fieldName) => !Utils.isNilOrEmpty(fieldName));

  const fieldsS = fields.join('JOINXYZSOLDEVELOUNIQUE');

  values.file = newFile;

  const isDifferentFieldMapping = fieldsS !== prevFieldsS;
  const [firstElem = {}] = newFile.csv?.data;
  const newMapping = fields.map((fieldName, idx) => ({
    from: {
      label: fieldName,
      value: fieldName,
      example: firstElem[fieldName],
    },
    // reset value when fields were changed
    to: isDifferentFieldMapping ? null : values.mapping[idx].to,
  }));

  values.mapping = newMapping;
};

function deleteRedundantFields(file) {
  delete file.csv.errors;
}
